/**
 * Collection Promo Height Sync
 *
 * PURPOSE:
 * Keeps the collection page promo banner (the promotional image in the first grid slot)
 * cropped to the same height as the product cards in its row. Without this, the promo
 * image's intrinsic height would dictate the row height and stretch the product cards.
 *
 * WHAT IT DOES:
 * - Measures the first product card's height
 * - Sets the promo image container to that height (image crops via object-fit: cover)
 * - Re-syncs when the product card resizes (e.g. images load) and on window resize
 *
 * USAGE:
 * Loaded conditionally in main-collection.liquid only when section.settings.promo-image
 * is set. No setup required—runs automatically on collection pages with a promo.
 *
 * DEPENDENCIES:
 * - Promo markup: .product-grid__item--promo .promo-image
 * - Product cards: .product-grid__item:not(.product-grid__item--promo)
 * - CSS: .promo-image img { object-fit: cover; height: 100%; }
 */
(function () {
  /** @type {number} */
  let raf = 0;
  /** @type {HTMLElement | null} */
  let promo;
  /** @type {HTMLElement | null} */
  let card;

  function sync() {
    if (!card || !promo) return;
    const h = card.offsetHeight;
    if (h > 0) promo.style.height = h + 'px';
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      sync();
      raf = 0;
    });
  }

  function init() {
    promo = document.querySelector('.product-grid__item--promo .promo-image');
    card = document.querySelector('.product-grid__item:not(.product-grid__item--promo)');
    if (!promo || !card) return;
    sync();
    new ResizeObserver(schedule).observe(card);
    window.addEventListener('resize', schedule, { passive: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
